
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: process.env.REACT_APP_MICROSOFT_REDERECT_URL,
  },
};
export const msalInstance = new PublicClientApplication(msalConfig);
